import { Validation, ValueObject } from '@singularsystems/neo-core';

export default class PaymentExportDetailsPagedCriteria extends ValueObject {

    constructor() {
        super();
        this.makeObservable();
    }

    public paymentExportId: number | null = null;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Payment Export Details Paged Criteria";
    }
}